import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-72508db1")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Pic = _resolveComponent("Pic")

  return (_openBlock(), _createBlock("div", {
    class: ["df-cross-center", {active: _ctx.active}],
    style: {"height":"28px","width":"28px"}
  }, [
    _createVNode(_component_Pic, {
      class: "pic",
      src: _ctx.path,
      width: "24",
      height: "24"
    }, null, 8, ["src"]),
    _createVNode(_component_Pic, {
      class: "pic active_pic",
      src: `${_ctx.path}_active`,
      width: "20",
      height: "20"
    }, null, 8, ["src"])
  ], 2))
})